import { Component, OnInit } from "@angular/core";
import { EdtellTabComponent } from "../../edtell-tabset/edtell-tab/edtell-tab.component";

@Component({
  selector: "app-edtell-front-facing-tab",
  templateUrl: "./edtell-front-facing-tab.component.html",
  styleUrls: ["./edtell-front-facing-tab.component.scss"],
})
export class EdtellFrontFacingTabComponent extends EdtellTabComponent {}
